import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import Search from '@groovehq/internal-design-system/lib/components/Search/Search'
import {
  queryStringToQueryId,
  queryIdToQuery,
} from 'ducks/searches/utils/query'
import { selectSearchEntitiesDenormalizedByQueryId } from 'ducks/searches/selectors'
import { selectCurrentTagById } from 'ducks/tags/selectors'
import { doFetchTagsV2 } from 'ducks/tags/actions'
import { debounce } from 'util/functions'
import TagDropdownMenu from './menu'
import TagDropdownIndicator from './indicator'
import { styles } from './styles'
import TagDropdownCreateButton from './createButton'

const { Button } = Dropdown

const defaultQueryId = 'entityType:tag pageSize:20 cursor:1'
const pleaseSelectTagOption = {
  name: 'Please select tag...',
  color: '#000000',
  conversationCount: null,
}
export default function TagDropdown(props) {
  const dispatch = useDispatch()
  const {
    onTagSelect,
    tagId: propTagId,
    onCreateTag,
    searchDelayMs = 200,
    size = 'big',
  } = props
  const [queryId, setQueryId] = useState(defaultQueryId)
  const [selectedTagId, setSelectedTagId] = useState(null)
  const { search = '' } = queryIdToQuery(queryId, { decodeUriKeys: ['search'] })
  const filteredTags = useSelector(state =>
    selectSearchEntitiesDenormalizedByQueryId(state, queryId)
  )
  const selectedTag =
    useSelector(state => selectCurrentTagById(state, selectedTagId)) ||
    pleaseSelectTagOption

  useEffect(
    () => {
      setSelectedTagId(propTagId)
    },
    [propTagId]
  )

  const doFetchTagsV2After = useMemo(
    () =>
      debounce(options => {
        dispatch(doFetchTagsV2(options))
      }, searchDelayMs),
    [dispatch, searchDelayMs]
  )

  useEffect(
    () => {
      doFetchTagsV2After({ queryId, skipLoaded: true })
    },
    [dispatch, queryId, doFetchTagsV2After]
  )

  const handleChangeSeach = useCallback(({ target }) => {
    const defaultQuery = queryIdToQuery(defaultQueryId)
    setQueryId(
      queryStringToQueryId(
        {
          ...defaultQuery,
          search: target.value,
        },
        { encodeUriKeys: ['search'] }
      )
    )
  }, [])

  const handleSelectTag = useCallback(
    id => {
      setSelectedTagId(id)
      if (onTagSelect) onTagSelect(id)
    },
    [onTagSelect]
  )

  return (
    <Dropdown
      overlay={<TagDropdownMenu tags={filteredTags} />}
      css={styles.menuStyle}
      onSelect={handleSelectTag}
      header={
        <div css={styles.fullWith}>
          <Search
            name="search"
            placeholder="Search all tags..."
            onChange={handleChangeSeach}
            value={search}
            css={[styles.fullWith, styles.hackPadding]}
          />
          <TagDropdownCreateButton onCreateTag={onCreateTag} />
        </div>
      }
    >
      <Button css={styles.dropdownBtn} size={size}>
        <TagDropdownIndicator {...selectedTag} />
      </Button>
    </Dropdown>
  )
}
